<template>
  <div :class="fixedStrokeClasses" />
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";
import { Stroke } from "@/types/types";

const props = withDefaults(
  defineProps<{
    pos: "left" | "right";
    classes?: string;
    stroke: Stroke;
    isHero?: boolean;
  }>(),
  {
    stroke: "mint",
    pos: "right",
    isHero: false,
  }
);

const { pos, stroke, isHero } = toRefs(props);

const fixedStrokeClasses = computed(() => {
  const hideOnMobile = isHero.value ? "hidden lg:block" : "";
  const posScreenHeight =
    pos?.value === "left"
      ? "-translate-x-[calc(100%-40px)] lg:-translate-x-[calc(100%-60px)] xl:-translate-x-[calc(100%-110px)]"
      : "translate-x-[calc(100%-40px)] lg:translate-x-[calc(100%-60px)] xl:translate-x-[calc(100%-110px)]";

  return `bg-${stroke?.value} absolute -inset-0 ${posScreenHeight} z-10 ${hideOnMobile}`;
});
</script>
